import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as H}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as i}from"../../icon-registry.js";const t=H`
<svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    static
    xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_4874_1128)">
        <g clip-path="url(#clip1_4874_1128)">
            <path
                d="M24.0342 24.0342H12.0171H0V12.111V0H12.0171H24.0342V12.111V24.0342Z"
                fill="white" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0 0V24H24V20.25H20.8125L19.4062 18.75L18 20.25H8.62498V12.6562H5.71874L9.56249 3.93749H13.2187L14.25 6.28123V3.93749H18.6562L19.6875 6.375L20.7187 3.93749H24V0H0ZM21.375 4.96874L20.25 7.78123L19.6875 9.18749L19.125 7.78123L18 4.96874H15.4687V11.4375L12.6562 4.96874H10.4062L7.59374 11.4375H9.46873L9.93748 10.2187H13.0312L13.5 11.4375H15.375H16.9687V7.59373V6.65621L17.3437 7.59373L18.9375 11.4375H20.3437L21.9375 7.59373L22.3125 6.65621V7.59373V11.4375H23.9062V4.96874H21.375ZM11.0625 7.31245L11.4375 6.375L11.8125 7.31245L12.4688 8.8125H10.5L11.0625 7.31245ZM21.4687 12.5625L19.5 14.625L17.5312 12.5625H15.375L18.375 15.7499L15.375 18.9375H17.4375L19.4062 16.875L21.375 18.9375H23.5313L20.5312 15.7499L23.5313 12.5625H21.4687ZM10.0312 12.5625V18.9375H15.375V17.5312H11.625V16.4062H15.2812V15.0937H11.625V13.9687H15.375V12.5625H10.0312V12.5625ZM22.2188 15.75L24 17.625V13.9687L22.2188 15.75Z"
                fill="#2671B9" />
        </g>
    </g>
    <defs>
        <clipPath id="clip0_4874_1128">
            <rect
                width="24"
                height="24"
                rx="12"
                fill="white" />
        </clipPath>
        <clipPath id="clip1_4874_1128">
            <rect
                width="24"
                height="24"
                rx="4"
                fill="white" />
        </clipPath>
    </defs>
</svg>
`,V=i("amex",t),c=i("american_express",t);export{V as AMEX,c as AmericanExpress};
